import React from 'react';
import {GlossaryProvider} from '@learningblocks/storybook-components';
import {Image} from '@learningblocks/shared-components';
import GlossaryIcon from './Glossary.Icon.svg';
import style from './style.module.scss';

export function GlossaryButton(props) {
  const {onOpenGlossary} = React.useContext(GlossaryProvider.Context);

  const onClick = (event) => {
    event.preventDefault();
    event.stopPropagation();
    onOpenGlossary('');
  };

  const className = `${style.glossaryButton} ${props.className}`;

  return (
    <span 
      tabIndex="0" 
      className={className} 
      onClick={onClick} 
      onKeyDown={(e)=>{
        if(e.keyCode === 13){
          onOpenGlossary('');
        }
      }}
      role="button" 
      aria-label='Open Glossary'
    >
      <Image src={GlossaryIcon} atl='' />
      <h5>Glossary</h5>
    </span>
  );
}
